<template>
   <div class="pt-10">
    <h6 class="text-md pb-2">Get the app</h6>
    <v-row class="p-0 m-0 w-100" align="center" justify="center">
      <v-col class="p-0 m-0 pb-5 mr-5">
        <v-btn class="text-transform-none" width="100%" height="50" dark :href="linkToFamilyHubForAndroid" target="_blank">
          <div class="image-wrapper">
            <img class="mr-3" height="30" :src="googlePlayIcon" />
          </div>
          <div>
            <div class="text-small">GET IT ON</div>
            <div>Google Play</div>
          </div>
        </v-btn>
      </v-col>
      <v-col class="p-0 m-0 pb-5 mr-5">
        <v-btn class="text-transform-none" width="100%" height="50" dark :href="linkToFamilyHubForIos" target="_blank">
          <div class="image-wrapper">
            <img class="mr-3" height="30" :src="appStoreIcon" />
          </div>
          <div>
            <span class="text-small">Download on the</span>
            <div>App Store</div>
          </div>
        </v-btn>
      </v-col>
    </v-row>
   </div>
</template>

<script>
  export default {
    name: 'GetApps',
    props: {
      linkToFamilyHubForAndroid: {
        type: String,
        required: true
      },
      linkToFamilyHubForIos: {
        type: String,
        required: true
      }
    },
    data(){
      return {
        googlePlayIcon: require("@/assets/icons/google-play.png"),
        appStoreIcon: require("@/assets/icons/app-store.png")
      }
    }
  };
</script>

<style scoped>
.text-transform-none {
  text-transform: none;
}

.text-small {
  font-size: .65em;
}

.text-md {
  color: #272727;
  font-size: 16px;
  font-weight: bold;
}

.image-wrapper {
  width: 40px;
  float: left;
}
</style>
